import { render, staticRenderFns } from "./DocumentoTabList.vue?vue&type=template&id=17820088&scoped=true"
import script from "./DocumentoTabList.vue?vue&type=script&lang=js"
export * from "./DocumentoTabList.vue?vue&type=script&lang=js"
import style0 from "./DocumentoTabList.vue?vue&type=style&index=0&id=17820088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17820088",
  null
  
)

export default component.exports